import axios from "axios";
const CONTROLLER_PATH = "Account";
class AccountService {
    //CREATE
    create(account) {
        return axios.post(CONTROLLER_PATH, account).then((response) => response.data);
    }

    addNote(accountId, text) {
        return axios.put(CONTROLLER_PATH + "/" + accountId + "/addNote", { text: text }).then((response) => response.data);
    }
    addClinicalNote(accountId, text, treatmentDate) {
        return axios.put(CONTROLLER_PATH + "/" + accountId + "/addClinicalNote", { text: text, treatmentDate: treatmentDate }).then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getAgeing(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/ageing", { params: urlParameters }).then((response) => response.data);
    }

    getageingmanagement(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getageingmanagement", { params: urlParameters }).then((response) => response.data);
    }

    getmanagementaccountswidgetdto(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/getmanagementaccountswidgetdto", { params: urlParameters }).then((response) => response.data);
    }

    getStatuses() {
        return axios.get(CONTROLLER_PATH + "/getStatuses").then((response) => response.data);
    }

    getUserAllowedStatuses() {
        return axios.get(CONTROLLER_PATH + "/getUserAllowedStatuses").then((response) => response.data);
    }

    getFundingTypes() {
        return axios.get(CONTROLLER_PATH + "/getFundingTypes").then((response) => response.data);
    }

    //UPDATE
    update(account) {
        return axios.put(CONTROLLER_PATH + "/" + account.account.id, account).then((response) => response.data);
    }
    resetstatus(account) {
        return axios.put(CONTROLLER_PATH + "/ResetStatus/" + account.id, account).then((response) => response.data);
    }
    grvimport(form) {
        return axios
            .post(CONTROLLER_PATH + "/GrvImport", form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    /*
    updateClaimDetails(id, formData) {
        return axios
            .put(CONTROLLER_PATH + '/updateClaimDetails/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }
*/
    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }

    //ACCOUNT FILES
    //CREATE
    createFile(accountId, formdata) {
        return axios
            .post(CONTROLLER_PATH + "/" + accountId + "/file", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    //READ
    getFileTypes() {
        return axios.get(CONTROLLER_PATH + "/getFileTypes").then((response) => response.data);
    }
    //UPDATE
    updateFile(entity) {
        return axios.put(CONTROLLER_PATH + "/" + entity.accountId + "/file/" + entity.id, entity).then((response) => response.data);
    }
    //DELETE
    deleteFile(accountId, accountFileId) {
        return axios.delete(CONTROLLER_PATH + "/" + accountId + "/file/" + accountFileId).then((response) => response.data);
    }
}

export default new AccountService();
